import { ConsumerPhoneNumberValue } from "../phoneNumberInput/ConsumerPhoneNumberValue.model"

export interface ConsumerInfoValue {
  firstName: string
  lastName: string
  emailAddress: string
  mobileNumber: ConsumerPhoneNumberValue
  countryCode?: string
}

export const createEmptyConsumerInfoValue = (): ConsumerInfoValue => ({
  firstName: "",
  lastName: "",
  emailAddress: "",
  mobileNumber: { countryCode: "", phoneNumber: "" },
  countryCode: undefined,
})
